import { render, staticRenderFns } from "./BankDialog.vue?vue&type=template&id=0d0aaf94&"
import script from "./BankDialog.vue?vue&type=script&lang=ts&"
export * from "./BankDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports